import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBRKJNuOL-MwgDSwTjnWhIy6YQwsxNpIeA",
  authDomain: "careervisionai-59b80.firebaseapp.com",
  projectId: "careervisionai-59b80",
  storageBucket: "careervisionai-59b80.firebasestorage.app",
  messagingSenderId: "661680007210",
  appId: "1:661680007210:web:cc33fab8101bfd07e17b53",
  measurementId: "G-FM1H6VNV0C"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();